module.exports = __webpack_public_path__ + "img/champion-betting-en.4d3aacfb.gif";